module.exports = __webpack_public_path__ + "img/not-found.a2f97868.svg";